import { Select } from 'antd';

import {
  CustomDropdown,
  CustomInput,
  CustomInputMobile,
  CustomLabel,
  CustomLabelMobile,
  StyledFormItem,
} from '@components/onboarding/form/steps/styles';
import {
  getWardrobeOptions,
  MinMaxValues,
  WardrobeLabel,
} from '@lib/utils/constants';
import { ONLY_DIGITS_REGEX } from '@lib/utils/constants/measurementConstants';
import { CoatLengthDropdown } from '@views/profile/CoatLengthDropdown';

const { Option } = Select;

type Props = {
  label: string;
  userAppearance: any;
  handleWardrobeChange: any;
  isMobile?: boolean;
  isMinor: boolean;
};

export const WardrobeQuestion = ({
  label,
  userAppearance,
  handleWardrobeChange,
  isMobile = false,
  isMinor,
}: Props): JSX.Element => {
  const wardrobeOptions = getWardrobeOptions(label, isMinor);

  return (
    <>
      {isMobile ? (
        <CustomLabelMobile label={WardrobeLabel[label]} requiredSymbol />
      ) : (
        <CustomLabel label={WardrobeLabel[label]} requiredSymbol />
      )}
      <StyledFormItem
        name={label}
        initialValue={userAppearance[label]}
        rules={[
          {
            required: true,
            validator: (_, value) => {
              // Check if the input field is a CustomInput
              if (!wardrobeOptions) {
                // This is a CustomInput
                if (!ONLY_DIGITS_REGEX.test(value)) {
                  return Promise.reject(WHOLE_NUMBER_ERROR_MESSAGE);
                }

                const intValue = parseInt(value);
                if (
                  intValue >= MinMaxValues[label].min &&
                  intValue <= MinMaxValues[label].max
                ) {
                  return Promise.resolve();
                }

                return Promise.reject(
                  `${WardrobeLabel[label]} must be between ${MinMaxValues[label].min} and ${MinMaxValues[label].max}`
                );
              } else {
                // This is a Dropdown
                if (!value) {
                  return Promise.reject(
                    `${WardrobeLabel[label]} selection required`
                  );
                }
                return Promise.resolve();
              }
            },
          },
        ]}
      >
        {label === 'us_coat_length' ? (
          <CoatLengthDropdown
            isMobile={isMobile}
            handleInputChange={handleWardrobeChange}
          />
        ) : wardrobeOptions ? (
          <CustomDropdown
            isMobile={isMobile}
            placeholder='Select Size'
            onChange={(value) => {
              handleWardrobeChange(label, value);
            }}
          >
            {wardrobeOptions.map((option, i) => (
              <Option key={`${option}${i}`} value={option}>
                {option}
              </Option>
            ))}
          </CustomDropdown>
        ) : isMobile ? (
          <CustomInputMobile
            placeholder='Type here'
            onChange={(event) => {
              handleWardrobeChange(label, event.target.value);
            }}
          />
        ) : (
          <CustomInput
            placeholder='Type here'
            onChange={(event) => {
              handleWardrobeChange(label, event.target.value);
            }}
          />
        )}
      </StyledFormItem>
    </>
  );
};

const WHOLE_NUMBER_ERROR_MESSAGE = 'Please enter a whole number';
